import server from "./server";

export const getDashboardHomeApi = async () => {
  const response = await server().get("/dashboardHome");
  return response.data;
};
